var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelWordpressFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#D54E21",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M12 5.571A6.436 6.436 0 0 1 18.429 12 6.436 6.436 0 0 1 12 18.429a6.436 6.436 0 0 1-6.429-6.43A6.436 6.436 0 0 1 12 5.572m.101 6.934-1.734 5.04a5.78 5.78 0 0 0 3.552-.093 1 1 0 0 1-.041-.08zm-5.38-2.857a5.78 5.78 0 0 0 2.757 7.554Zm10.35-.421q.04.276.04.594c0 .587-.11 1.246-.44 2.07l-1.765 5.105a5.777 5.777 0 0 0 2.166-7.769M12 6.22a5.77 5.77 0 0 0-4.83 2.605c.137.005.264.007.373.007.604 0 1.54-.073 1.54-.073.312-.019.348.44.037.476 0 0-.313.037-.661.055l2.104 6.26 1.265-3.793-.9-2.467a11 11 0 0 1-.606-.055c-.312-.018-.275-.495.036-.476 0 0 .955.073 1.523.073.604 0 1.54-.073 1.54-.073.312-.019.348.44.037.476 0 0-.314.037-.661.055l2.088 6.213.577-1.926c.25-.8.44-1.374.44-1.869 0-.714-.257-1.209-.477-1.594-.293-.476-.568-.879-.568-1.355 0-.532.403-1.026.971-1.026q.038.001.075.005A5.76 5.76 0 0 0 12 6.22"
}))));
export default SvgGemChannelWordpressFilled;